import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserState } from 'types/store.types'
import { onSignOutSuccess } from './sessionSlice'

export const initialState: UserState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    role: '',
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
        setUser: (_, action: PayloadAction<UserState>) => action.payload,
        userLoggedOut: () => initialState,
	},
	// R-561: every sign-out (user menu, the sign-out hook, a 401 in BaseService)
	// dispatches onSignOutSuccess. The whole `auth` slice is persisted, so the
	// admin's name, email and role must go with the token, not stay in localStorage.
	extraReducers: (builder) => {
		builder.addCase(onSignOutSuccess, () => initialState)
	},
})

export const { setUser } = userSlice.actions

export default userSlice.reducer
